import { Component, OnInit } from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-provider-modal-export-dealer',
  templateUrl: './provider-modal-export-dealer.component.html',
  styles: []
})
export class ProviderModalExportDealerComponent extends ExcTranslation implements OnInit {
  selectedClient = 0;
  clients: any[] = [];
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig) {
    super();
    const _self = this;
  }

  ngOnInit() {
    const _self = this;
    _self.clients.push({Mdt_Id: 0 , Mdt_Name: _self.getGlobal('SelectAll')  });
    _self.clients = _self.overlayConfig.data.Client;
  }
  export() {
    const _self = this;
    if (_self.selectedClient === 0) {
      _self.selectedClient = null;
    }
    _self.overlayRef.close({proceed: true, selectedClient: _self.selectedClient});
  }
}
